import CloseIcon from "@mui/icons-material/Close";
import { Box, Button, IconButton, TextField, Typography } from "@mui/material";
import { Modal } from "app/components/Modal";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { selectAddOnTyingStripModal } from "../../../redux/selector";
import { actions } from "../../../redux/slice";
import { ADD_ON_FORM_I18N_PREFIX } from "../data";
import { useStyles } from "./styles";

const AddTyingStripModal = () => {
  const { t, i18n } = useTranslation();
  const styles = useStyles();
  const dispatch = useDispatch();
  const tyingStripModal = useSelector(selectAddOnTyingStripModal);

  if (!tyingStripModal) {
    return null;
  }

  const { open, height, note } = tyingStripModal;

  const handleClose = () => {
    dispatch(actions.closeAddOnTyingStripModal());
  };

  const handleAdd = () => {
    dispatch(actions.submitAddOnTyingStripModal());
  };

  const heightLabel = t(`${ADD_ON_FORM_I18N_PREFIX}.TABLES.COLUMNS.HEIGHT`);
  const noteLabel = t(`${ADD_ON_FORM_I18N_PREFIX}.FIELDS.NOTE`);

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        className={styles.tyingStripModal}
        sx={{
          direction: i18n.dir(),
        }}
      >
        <Box className={styles.tyingStripModalHeader}>
          <Typography className={styles.tyingStripModalTitle}>
            {t(`${ADD_ON_FORM_I18N_PREFIX}.TABLES.ADD_TYING_STRIP`)}
          </Typography>
          <IconButton
            className={styles.tyingStripModalClose}
            onClick={handleClose}
            aria-label={t("BUTTONS.CANCEL")}
          >
            <CloseIcon />
          </IconButton>
        </Box>

        <Box className={styles.tyingStripModalBody}>
          <Box className={styles.tyingStripModalField}>
            <Typography className={styles.tyingStripModalLabel}>{heightLabel}</Typography>
            <TextField
              className={styles.tyingStripModalInput}
              fullWidth
              variant="outlined"
              placeholder={heightLabel}
              value={height}
              InputProps={{ notched: false }}
              onChange={(event) =>
                dispatch(
                  actions.updateAddOnTyingStripModalField({
                    field: "height",
                    value: event.target.value,
                  })
                )
              }
            />
          </Box>
          <Box className={styles.tyingStripModalField}>
            <Typography className={styles.tyingStripModalLabel}>{noteLabel}</Typography>
            <TextField
              className={styles.tyingStripModalInput}
              fullWidth
              variant="outlined"
              placeholder={noteLabel}
              value={note}
              InputProps={{ notched: false }}
              onChange={(event) =>
                dispatch(
                  actions.updateAddOnTyingStripModalField({
                    field: "note",
                    value: event.target.value,
                  })
                )
              }
            />
          </Box>
        </Box>

        <Box className={styles.tyingStripModalFooter}>
          <Button
            className={styles.tyingStripModalAddBtn}
            variant="contained"
            disableElevation
            onClick={handleAdd}
          >
            {t("BUTTONS.ADD")}
          </Button>
          <Button
            className={styles.tyingStripModalCancelBtn}
            variant="outlined"
            onClick={handleClose}
          >
            {t("BUTTONS.CANCEL")}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default AddTyingStripModal;
